export const obtenerObjLocal = ({key}) => {

    return window.localStorage.getItem(key)

}